module.exports = __webpack_public_path__ + "img/radioOff.cca71c29.svg";